<app-base-modal
  [activeModal]="activeModal"
  [title]="'plan.modify_modal.title' | translate"
  [secondaryTitle]="employeeName"
>
  <div class="content">
    <form class="form" [formGroup]="planForm">
      <div class="form-row">
        <label class="row-label">{{
          "plan.modify_modal.project_name" | translate
        }}</label>
        <label class="text-end">{{ projectName }}</label>
      </div>
      <div class="form-row">
        <label for="from" class="row-label">{{
          "plan.modify_modal.start" | translate
        }}</label>
        <div class="wrapper">
          <input formControlName="from" id="from" type="date" />
          <span
            *ngIf="
              planForm.get('from')?.hasError('required') &&
              planForm.get('from')?.touched
            "
            class="form-error"
          >
            {{ "form.error.required" | translate }}
          </span>
        </div>
      </div>
      <div class="form-row">
        <label for="to" class="row-label">{{
          "plan.modify_modal.end" | translate
        }}</label>
        <div class="wrapper">
          <input formControlName="to" id="to" type="date" />
          <span
            *ngIf="
              planForm.get('to')?.hasError('required') &&
              planForm.get('to')?.touched
            "
            class="form-error"
          >
            {{ "form.error.required" | translate }}
          </span>
          <span *ngIf="planForm.hasError('invalidDate')" class="form-error">
            {{ "validation_message.invalid.to_earlier_than_from" | translate }}
          </span>
        </div>
      </div>
      <div class="form-row">
        <label for="percentage" class="row-label">
          {{ "plan.modify_modal.percentage" | translate }}
        </label>
        <div class="wrapper">
          <div class="range-input-wrapper">
            <input
              type="range"
              min="0"
              max="100"
              step="5"
              formControlName="percentage"
              [value]="planForm.value.percentage"
            />
            <input
              id="percentage"
              type="number"
              min="0"
              max="100"
              class="percentage-number-input"
              formControlName="percentage"
              [value]="planForm.value.percentage"
              (blur)="validatePercentageField()"
            />
          </div>
          <span
            *ngIf="
              planForm.get('percentage')?.hasError('min') &&
              planForm.get('percentage')?.touched
            "
            class="form-error"
          >
            {{ "form.error.percentage_min_value" | translate }}
          </span>
          <span
            *ngIf="
              planForm.get('percentage')?.hasError('required') &&
              planForm.get('percentage')?.touched
            "
            class="form-error"
          >
            {{ "form.error.required" | translate }}
          </span>
        </div>
      </div>
      <div class="form-row">
        <label for="description" class="row-label">
          {{ "plan.modify_modal.description" | translate }}
        </label>
        <div class="wrapper">
          <textarea
            id="description"
            class="px-2"
            rows="4"
            placeholder="{{ 'plan.modify_modal.placeholder' | translate }}"
            formControlName="description"
          ></textarea>
        </div>
      </div>
      <div class="form-row">
        <label class="row-label">{{
          "plan.modify_modal.competency" | translate
        }}</label>
        <div class="w-50">
          <app-competency-pill-container
            [competencies]="competencies"
            [allCompetencies]="allCompetencies"
            [employeeCompetencies]="employeeCompetencies"
            [commands]="commands"
            [isAddPillButtonActive]="true"
            (newCompetencyEvent)="checkAndAddNewCompetency($event)"
          ></app-competency-pill-container>
        </div>
      </div>
    </form>
  </div>
  <div *ngIf="error" class="error mt-4">
    <ngb-alert class="alert" type="danger" (closed)="closeAlert()">
      {{ errorMessage }}
    </ngb-alert>
  </div>
  <ng-container modal-actions>
    <button class="btn secondary-btn" (click)="activeModal.close()">
      {{ "button.cancel" | translate }}
    </button>
    <button class="btn primary-btn" (click)="updatePlan()">
      {{ "button.save" | translate }}
    </button>
  </ng-container>
</app-base-modal>
